export default "__VITE_ASSET__VZeAHAdJ__"